export const ActiveCallTestIds = {
  DTMF: 'active-call.dtmf-button',
  HOLD: 'active-call.hold-button',
  HANGUP: 'active-call.hangup-button',
  KEYPAD: 'active-call.keypad-button',
};
